angular.module("practiceData.components", [])
    .component("practiceData", {
        templateUrl: "ng/components/monitorPratica/practiceData/practiceData.view.html",
        bindings: {
            model: "=",
            loading: "<",
            inMonitor: '<'
        },
        controllerAs: "practiceDataCtrl",
        controller: function PracticeData(
            $portalService,
            $timeout,
            $download
        ) {
            var self = this;

            self.numberOfCharMax = 20;

            self.$onInit = function () {
                self.model = self.model;
                self.$portalService = $portalService
                $('#accordion').addClass('p-0');
                checkAndEnableTooltip();
            };

            self.$onChanges = function (changed) {
                if (changed && typeof changed.loading.currentValue != "undefined" && !!!changed.loading.currentValue) {
                    checkAndEnableTooltip();
                }
            }

            var checkAndEnableTooltip = function () {
                $timeout(function () {
                    if (self.model && self.model.financialVendor && self.model.financialVendor.riUserG && self.model.financialVendor.riUserG.ragioneSociale && self.model.financialVendor.riUserG.ragioneSociale.length > self.numberOfCharMax) {
                        self.enableToltipVendor = true;
                    }

                }, 1500)

                $timeout(function () {
                    if (self.model && self.model.financialCustomer && self.model.financialCustomer.metadata && self.model.financialCustomer.metadata.riUserG && self.model.financialCustomer.metadata.riUserG.ragioneSociale && self.model.financialCustomer.metadata.riUserG.ragioneSociale.length > self.numberOfCharMax) {
                        self.enableToltipCliente = true;
                    }

                }, 1500)
            }

            self.stampaDocRiepilogo = function () {
                self.loaderCallRest = true;
                var input = {
                    numContratto: self.model.leasingData.contratto.numero,
                    numModulo: self.model.leasingData.contratto.modulo
                }
                var url = "/simulator/contract/stampaDocRiepilogo/service-infos/"
                $download.getGenericDownload(url, input)
                    .then(function (response) {
                        console.log(response);
                        self.loaderCallRest = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.loaderCallRest = false;
                    })
            }
        }
    });